"use client";

import React, { useState } from "react";
import {
    FiSearch,
    FiHeart,
    FiMenu,
    FiChevronDown,
    FiChevronRight,
    FiSmartphone,
    FiDroplet,
    FiFeather,
    FiSun,
    FiShoppingBag,
    FiGift,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Basket from "../../components/basket/Basket";
import UserProfile from "../../components/userProfile/UserProfile";

const categories = [
    "Vapes & Devices",
    "E-Liquids",
    "Cannabis & Hemp",
    "Lingerie",
    "Wellness",
    "Accessories",
    "Brands",
    "Deals",
    "New Arrivals",
];

const shopCategories = [
    {
        name: "Vapes & Devices",
        description: "Disposables, Mods, Pods & More",
        icon: FiSmartphone,
        href: "/shop",
    },
    {
        name: "E-Liquids",
        description: "Top Brands & Flavors",
        icon: FiDroplet,
        href: "/shop",
    },
    {
        name: "Cannabis & Hemp",
        description: "Flower, Edibles, CBD & More",
        icon: FiFeather,
        href: "/shop",
    },
    {
        name: "Lingerie",
        description: "Sets, Bras, Intimates & More",
        icon: FiHeart,
        href: "/shop",
    },
    {
        name: "Wellness",
        description: "Self Care, Massage & Relaxation",
        icon: FiSun,
        href: "/shop",
    },
    {
        name: "Accessories",
        description: "Lifestyle, Storage & Essentials",
        icon: FiShoppingBag,
        href: "/shop",
    },
    {
        name: "Adult Toys",
        description: "For Pleasure & Exploration",
        icon: FiFeather,
        href: "/shop",
    },
    {
        name: "Gift Ideas",
        description: "Curated Gifts for Every Mood",
        icon: FiGift,
        href: "/shop",
    },
];

function Logo() {
    return (
        <Link
            to="/"
            className="flex w-[190px] shrink-0 flex-col items-center justify-center leading-none"
            aria-label="Pufframa home"
        >
            <div className="whitespace-nowrap text-[21px] font-black tracking-[-1.1px]">
                <span className="text-[#111111]">PUFF</span>
                <span className="text-[#111111]">RAMA</span>
            </div>

            <div className="mt-[3px] whitespace-nowrap text-[9px] font-bold  tracking-[2px] text-[#252525]">
                No Business Drama
            </div>
        </Link>
    );
}

function CategoryDropdown() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className="group relative z-50 shrink-0"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <button
                type="button"
                aria-haspopup="true"
                aria-expanded={isOpen}
                onClick={() => setIsOpen((previous) => !previous)}
                className="flex h-[24px] items-center gap-[6px] rounded-[5px] bg-[#6827d9] px-[11px] text-[9px] font-semibold text-white transition-colors hover:bg-[#5420b9]"
            >
                <FiMenu size={12} />
                <span>Shop by Category</span>
                <FiChevronDown
                    size={10}
                    className={`transition-transform ${isOpen ? "rotate-180" : ""
                        }`}
                />
            </button>

            {isOpen && (
                <div className="absolute left-0 top-full z-50 w-[245px] border border-[#e9e6ee] bg-white py-0 shadow-[0_5px_18px_rgba(30,20,50,0.12)]">
                    {shopCategories.map((category, index) => {
                        const Icon = category.icon;

                        return (
                            <Link
                                key={category.name}
                                to={category.href}
                                onClick={() => setIsOpen(false)}
                                className={`flex min-h-[39px] items-center gap-[9px] px-[10px] py-[5px] transition-colors hover:bg-[#f8f5ff] ${index !== shopCategories.length - 1
                                        ? "border-b border-[#f0edf3]"
                                        : ""
                                    }`}
                            >
                                <span className="flex w-[15px] shrink-0 justify-center text-[#454052]">
                                    <Icon size={14} strokeWidth={1.5} />
                                </span>

                                <span className="min-w-0 flex-1">
                                    <span className="block text-[13px] font-semibold leading-[15px] text-[#33303e]">
                                        {category.name}
                                    </span>

                                    <span className="mt-[2px] block text-[7px] leading-[9px] text-[#85818f]">
                                        {category.description}
                                    </span>
                                </span>

                                <FiChevronRight
                                    size={11}
                                    className="shrink-0 text-[#aaa5b3]"
                                />
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

function HeaderAction({ icon: Icon, label, count }) {
    return (
        <span className="relative flex shrink-0 items-center gap-[5px] text-[#303047] transition-colors hover:text-[#6828df]">
            <span className="relative flex h-[21px] w-[21px] items-center justify-center">
                <Icon size={17} strokeWidth={1.7} />

                {count != null && (
                    <span className="absolute -right-[5px] -top-[5px] flex h-[13px] min-w-[13px] items-center justify-center rounded-full bg-[#6928dc] px-[3px] text-[8px] font-bold leading-none text-white">
                        {count}
                    </span>
                )}
            </span>

            <span className="hidden whitespace-nowrap text-[9px] font-semibold xl:inline">
                {label}
            </span>
        </span>
    );
}

function HeaderActions() {
    const isLoggedIn = useSelector(
        (state) => state.auth.isLoggedIn
    );

    return (
        <div className="ml-auto flex shrink-0 items-center gap-[10px] pl-1 sm:gap-[14px] lg:gap-[18px]">
            {/* Existing account component */}
            <div className="flex items-center text-black [&_*]:text-black">
                <UserProfile isLoggedIn={isLoggedIn} />
            </div>

            {/* Wishlist route */}
            {/* <Link
        to="/wishlist"
        aria-label="Wishlist"
        className="text-inherit no-underline"
      >
        <HeaderAction icon={FiHeart} label="Wishlist" />
      </Link> */}

            {/* Existing cart component */}
            <div className="relative flex items-center">
                <Basket className="relative text-[#303047]" />
            </div>
        </div>
    );
}

export default function Header1() {
    const [search, setSearch] = useState("");

    const handleSearch = (event) => {
        event.preventDefault();

        const query = search.trim();

        if (!query) return;

        window.location.href = `/shop?search=${encodeURIComponent(query)}`;
    };

    return (
        <>
            <header className="relative z-40 w-full border-x border-t border-[#dcd9df] bg-white font-sans text-[#22222e]">
                {/* Top header */}
                <div className="flex min-h-[50px] items-center border-b border-[#eeeaf1] px-3 sm:px-5 lg:px-[4.5%]">
                    <div className="flex min-w-0 flex-1 items-center">
                        <div className="flex w-[190px] shrink-0 items-center justify-start">
                            <Logo />
                        </div>

                        {/* Desktop search */}
                        <form
                            onSubmit={handleSearch}
                            className="mx-3 hidden h-[29px] min-w-0 flex-1 items-center overflow-hidden rounded-[6px] border border-[#eeeaf4] bg-[#f8f7fb] sm:flex"
                        >
                            <FiSearch
                                className="ml-[9px] shrink-0 text-[#77768d]"
                                size={12}
                            />

                            <input
                                type="search"
                                value={search}
                                onChange={(event) => setSearch(event.target.value)}
                                placeholder="Search for vapes, e-liquids, cannabis, lingerie, wellness and more..."
                                className="h-full min-w-0 flex-1 bg-transparent px-[7px] text-[9px] text-[#303047] outline-none placeholder:text-[#858397]"
                            />

                            <button
                                type="submit"
                                aria-label="Search"
                                className="flex h-[29px] w-[32px] shrink-0 items-center justify-center rounded-r-[5px] bg-[#6928dc] text-white hover:bg-[#5420b9]"
                            >
                                <FiSearch size={15} strokeWidth={2} />
                            </button>
                        </form>

                        {/* Existing account and cart behavior */}
                        <HeaderActions />
                    </div>
                </div>

                {/* Mobile search */}
                <div className="border-b border-[#eeeaf1] px-3 py-2 sm:hidden">
                    <form
                        onSubmit={handleSearch}
                        className="flex h-[34px] items-center overflow-hidden rounded-md border border-[#eeeaf4] bg-[#f8f7fb]"
                    >
                        <FiSearch
                            className="ml-2 shrink-0 text-[#77768d]"
                            size={14}
                        />

                        <input
                            type="search"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            placeholder="Search products..."
                            className="min-w-0 flex-1 bg-transparent px-2 text-xs outline-none"
                        />

                        <button
                            type="submit"
                            aria-label="Search"
                            className="flex h-full w-9 shrink-0 items-center justify-center bg-[#6928dc] text-white"
                        >
                            <FiSearch size={16} />
                        </button>
                    </form>
                </div>

                {/* Category navigation */}
                <nav className="relative flex h-[28px] items-center gap-0 px-3 sm:px-5 lg:px-[4.3%]">
                    <CategoryDropdown />

                    <div className="ml-3 hidden min-w-0 flex-1 items-center justify-between gap-1 lg:flex">
                        {categories.map((category, index) => {
                            const hasDropdown = index <= 5;

                            return (
                                <Link
                                    key={category}
                                    to={
                                        category === "Deals"
                                            ? "/shop"
                                            : category === "New Arrivals"
                                                ? "/shop"
                                                : category === "Brands"
                                                    ? "/shop"
                                                    : shopCategories.find(
                                                        (item) => item.name === category
                                                    )?.href || "/shop"
                                    }
                                    className="flex shrink-0 items-center gap-1 whitespace-nowrap px-1.5 py-2 text-[10px] font-bold leading-5 text-[#282735] transition-colors hover:text-[#6827d9] xl:text-[12px]"
                                >
                                    {category}

                                    {hasDropdown && (
                                        <FiChevronDown
                                            size={13}
                                            strokeWidth={2}
                                        />
                                    )}
                                </Link>
                            );
                        })}
                    </div>

                    {/* Currency selector - visual only */}
                    <button
                        type="button"
                        className="ml-auto flex h-[22px] shrink-0 items-center gap-[6px] rounded-[5px] bg-[#f8f7fb] px-[7px] text-[9px] font-medium text-[#393747] lg:ml-[10px]"
                    >
                        <span aria-hidden="true" className="text-[12px]">
                            🇺🇸
                        </span>
                        <span>USD</span>
                        <FiChevronDown size={10} />
                    </button>
                </nav>

                {/* Compact navigation on smaller screens */}
                <div className="flex items-center gap-5 overflow-x-auto border-t border-[#f3f0f5] px-3 py-2 lg:hidden">
                    {categories.map((category) => {
                        const href =
                            shopCategories.find(
                                (item) => item.name === category
                            )?.href ||
                            (category === "Deals"
                                ? "/shop"
                                : category === "New Arrivals"
                                    ? "/shop"
                                    : category === "Brands"
                                        ? "/shop"
                                        : "/shop");

                        return (
                            <Link
                                key={category}
                                to={href}
                                className="shrink-0 whitespace-nowrap text-[14px] font-medium text-[#282735] hover:text-[#6827d9]"
                            >
                                {category}
                            </Link>
                        );
                    })}
                </div>
            </header>


        </>
    );
}

